<template>
  <div tabindex="0" class="hide-outline" style="margin-top: 58px">
    <ui-row>
      <ui-col cols="12">
        <ui-card style="padding: 20px">
          <div class="level-up-container is-flex is-align-items-center mb-2">
            <i class="fas fa-level-up-alt fa-xs mr-1" @click="GoBack()" />
            <p class="is-size-7 is-underlined" @click="GoBack()"> {{ $t('roundhistory.back') }}</p>
          </div>
          <div>
            <p class="mt-1">{{ $t('roundhistory.title') }}</p>
          </div>
          <ui-title class="has-text-white mr-6" style="white-space: nowrap">
            {{ building?.name || $t('roundhistory.unknown_building') }}
          </ui-title>
          <div class="select-container mt-2 mb-2">
            <!-- Kontrollrond select -->
            <v-select
              v-model="selectedRound"
              :options="rounds"
              label="name"
              trackBy="id"
              :placeholder="$t('roundhistory.select_round')"
              class="responsive-select"
              @open="removeTooltips"
            >
              <template #noResult>
                <span>{{ $t('roundhistory.no_rounds') }}</span>
              </template>
              <template #caret="{ toggle }">
                <span class="caret" @mousedown.prevent="toggle">
                  <i class="fas fa-caret-down caret-inner"></i>
                </span>
              </template>
              <!-- Truncate selected option -->
              <template #selected-option="{ option, deselect }">
                <span :title="option.name">{{ truncate(option.name) }}</span>
              </template>
            </v-select>

            <!-- Våning select -->
            <v-select
              v-model="selectedFloor"
              :options="floors"
              label="name"
              trackBy="id"
              :placeholder="$t('roundhistory.select_floor')"
              class="responsive-select"
              @open="removeTooltips"
                
            >
              <template #noResult>
                <span>{{ $t('roundhistory.no_floors') }}</span>
              </template>
              <template #caret="{ toggle }">
                <span class="caret" @mousedown.prevent="toggle">
                  <i class="fas fa-caret-down caret-inner"></i>
                </span>
              </template>
              <!-- Truncate selected option -->
              <template #selected-option="{ option, deselect }">
                <span :title="option.name">{{ truncate(option.name) }}</span>
              </template>
            </v-select>
             <button class="toggle-btn" @click="showGroupNumbers = !showGroupNumbers">
    {{ showGroupNumbers ? $t('roundhistory.show_position_numbers') : $t('roundhistory.show_icon') }}
  </button>
   <button class="toggle-btn"  @click="downloadPDF">{{ $t('roundhistory.download_pdf') }}</button>
          </div>
        </ui-card>
      </ui-col>
    </ui-row>
    <div>
      <FloorRoundDisplay ref="floorDisplay" :floor="selectedFloor" :round="selectedRound"   :showgroupnumbers="showGroupNumbers"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import FloorRoundDisplay from "./components/FloorRoundDisplay.vue";

export default {
  name: "RoundHistoryView",
  components: {
    FloorRoundDisplay,
  },

  data() {
    return {
      selectedFloor: null,
      selectedRound: null,
      floors: [],
      rounds: [],
      allRounds: [],
      selectedRound: null,
      selectedFloor: null,
        showGroupNumbers: true,
        newshowGroupNumbers:true // eller false
    };
  },
  mounted() {
    const removeTooltips = () => {
      const options = this.$el.querySelectorAll(".multiselect__option");
      options.forEach((opt) => {
        opt.removeAttribute("data-select");
        opt.removeAttribute("data-deselect");
      });

      // Ta bort title från dropdown toggle för att ta bort hover-tooltip på vald item
      const toggles = this.$el.querySelectorAll(".vs__dropdown-toggle");
      toggles.forEach((toggle) => toggle.removeAttribute("title"));
    };

    removeTooltips();

    this.$watch("selectedFloor", removeTooltips);
    this.$watch("selectedRound", removeTooltips);
  },

  computed: {
    buildingId() {
      return this.$route.params.buildingId;
    },
    ...mapGetters("buildingStore", ["building"]),
  },
  created() {
    this.getBuilding(this.buildingId)
      .then(() => {
        this.floors = this.building.floors.map((floor) => ({
          id: floor.id,
          name: floor.name || this.$t('roundhistory.floor_label_with_level', { level: floor.level }),
        }));

        return this.loadRoundHistories(this.buildingId); // byt till ny metod
      })
      .then(() => {
        console.log("Round histories hämtade");
      })
      .catch((err) => {
        console.error("Fel vid hämtning:", err);
      });
  },

  watch: {
     showGroupNumbers(newVal) {
       this.showGroupNumbers = newVal;
       console.log('showGroupNumbers changed:', this.newshowGroupNumbers)  },
    selectedFloor(newVal) {
      this.selectedFloor = this.building.floors.find((floor) => floor.id === newVal.id);
    },
    selectedRound(newVal) {
      if (!newVal || !newVal.id) {
        this.selectedRound = null;
        return;
      }

      this.selectedRound = this.allRounds.find((round) => round.id === newVal.id);

      if (!this.selectedRound || !this.selectedRound.roundHistoryInfos?.length) return;

      const floorNamesInRound = this.selectedRound.roundHistoryInfos
        .map((info) => info.floorName?.toLowerCase())
        .filter(Boolean);
      const buildingFloors = this.building.floors;

      if (!buildingFloors.length) return;

      const firstBuildingFloor = buildingFloors[0];

      const matchInRound = floorNamesInRound.includes(
        firstBuildingFloor.name?.toLowerCase()
      );

      let selected = null;

      if (matchInRound) {
        selected = firstBuildingFloor;
      } else {
        selected =
          buildingFloors.find((floor) =>
            floorNamesInRound.includes(floor.name?.toLowerCase())
          ) || firstBuildingFloor; // fallback till första våningen
      }

      this.selectedFloor = {
        id: selected.id,
        name: selected.name || `Våning ${selected.level}`,
      };
    },
  },

  methods: {
    ...mapActions("roundHistoryStore", ["getRoundHistories"]),
    ...mapActions("buildingStore", ["getBuilding"]),

    removeTooltips() {
      this.$nextTick(() => {
        const options = this.$el.querySelectorAll(".multiselect__option");
        options.forEach((opt) => {
          opt.removeAttribute("data-select");
          opt.removeAttribute("data-deselect");
          opt.removeAttribute("title");
        });
      });
    },
    

    GoBack() {
      this.$router.go(-1);
    },

    fetchHistory() {
      // Här skriver du logik för att hämta data baserat på valen
    },

    // ✅ Flyttad hit!
    loadRoundHistories(buildingId) {
      return this.getRoundHistories(buildingId)
        .then((data) => {
          if (!Array.isArray(data) || data.length === 0) {
            this.rounds = [];
            this.allRounds = [];
            this.selectedRound = null;
            return;
          }

          // Sortera nyast först
          const sorted = data
            .slice()
            .sort((a, b) => new Date(b.created) - new Date(a.created));

          // Visa-rundor (för <v-select>)
          this.rounds = sorted.map((round) => {
            const name = round.name || this.$t('roundhistory.unnamed_round');
            const date = round.created
              ? new Date(round.created).toISOString().slice(0, 10)
              : "okänt datum";
            return {
              id: round.id,
              name: `${name} (${date})`,
            };
          });

          this.allRounds = sorted;

          // Sätt första ronden automatiskt
          const firstRound = this.rounds[0];
          if (firstRound) {
            this.selectedRound = firstRound;
          }
        })
        .catch((err) => {
          this.rounds = [];
          this.allRounds = [];
          this.selectedRound = null;
        });
    },
async downloadPDF() {
  if (!this.$refs.floorDisplay) return;
  const element = this.$refs.floorDisplay.$el;

  // Skapa canvas med måttlig upplösning
  const canvas = await html2canvas(element, { useCORS: true, scale: 2 });
  const imgData = canvas.toDataURL("image/png");

  const pdf = new jsPDF("portrait", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const padding = 10; // mm
  let imgWidth = pageWidth - 2 * padding;
  let imgHeight = (canvas.height * imgWidth) / canvas.width;

  // Om bilden är högre än A4-sidan minus padding, skala ner proportionerligt
  if (imgHeight > pageHeight - 2 * padding) {
    const scale = (pageHeight - 2 * padding) / imgHeight;
    imgWidth *= scale;
    imgHeight *= scale;
  }

  // Lägg in bilden med padding
  pdf.addImage(imgData, "PNG", padding, padding, imgWidth, imgHeight);
   // Skapa ett säkert filnamn
  const roundName = this.selectedRound?.name || this.$t('roundhistory.unknown_round');
  const floorName = this.selectedFloor?.name || this.$t('roundhistory.unknown_floor');

  const safeFileName = `${roundName}${floorName}`
    .replace(/\s+/g, "")        // ersätt mellanslag med _
    .replace(/[\/\\:*?"<>|]/g, ""); // ta bort ogiltiga tecken

  pdf.save(`${safeFileName}.pdf`);
}
  },
    

};
</script>

<style scoped lang="scss">
/* === LOKALA STILAR === */

.select-container {
  display: flex;
  gap: 1rem;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.responsive-select {
  max-width: 400px; /* Sätt maxbredd */
  min-width: 200px; /* Kan sättas för att undvika att den blir för liten */
  position: relative;
}

.caret {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 60px;
  max-width: 60px;
  text-align: center;
  cursor: pointer;
  color: #888;
  transition: color 0.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: all;
  user-select: none;
}

.caret-inner {
  font-size: 16px;
}

:deep(.v-select:hover .caret),
.caret:hover {
  color: #ef7c21;
}

.level-up-container {
  .fa-level-up-alt {
    transform: rotateY(180deg);
  }
  &:hover {
    cursor: pointer;
  }
}

.ui-card {
  overflow: visible;
  min-height: 200px;
}

/* === STIL FÖR TREDJEPARTSKOMPONENTER === */

:deep(.multiselect__option--highlight) {
  background: #ef7c21 !important;
  font-size: 10px !important;
}

:deep(.multiselect__option) {
  font-size: 10px !important;
  max-height: 10px !important;
}

:deep(.multiselect__input),
:deep(.multiselect__single) {
  font-size: 12px !important;
  max-height: 30px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 300px;
  display: inline-block;
  vertical-align: middle;
}

:deep(.vs__dropdown-menu) {
  position: absolute !important;
  z-index: 1000;
}
:deep(span:after) {
  content: none !important;
}
.toggle-btn {
  background: rgb(35, 40, 45);       /* snygg röd bakgrund */
  color: #fff;                /* vit text */
  border: none;
  padding: 8px 14px;
  border-radius: 2px;        /* rundad */
  cursor: pointer;
  font-weight: 500;
  font-size: 12px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  transition: background 0.2s, transform 0.1s;
}

.toggle-btn:hover {
  background:  #ef7c21;
}

.toggle-btn:active {
  transform: scale(0.95);
}
/* === OBS: UNDVIK GLOBALA STILAR I SCOPED === */
/* flytta detta till global fil om du verkligen behöver det */
</style>
